import { useContext } from 'react';
import { BrandingStoreContext } from './brandingStore';

export function useBranding() {
  const context = useContext(BrandingStoreContext);
  if (!context) {
    throw new Error('useBranding must be used within BrandingProvider');
  }

  return context;
}
